import {
  ServerErrorMiddleware,
  ServerErrorMiddlewareFn,
} from "./ServerErrorMiddleware";
import { ServerErrorFactory } from "./ServerErrorFactory";

export class ServerErrorMiddlewareFactory {
  private middlewares: Array<ServerErrorMiddleware | ServerErrorMiddlewareFn> =
    [];

  /**
   * Creates a new ServerErrorMiddlewareFactory instance.
   * @param coreFactory The final factory that actually parses the response into an Error object
   */
  constructor(private readonly coreFactory: ServerErrorFactory) {}

  public use(
    middleware: ServerErrorMiddleware | ServerErrorMiddlewareFn
  ): this {
    this.middlewares.push(middleware);
    return this;
  }

  public handle: ServerErrorFactory = async (response, request) => {
    // 1. Run all side-effects (middlewares)
    for (const middleware of this.middlewares) {
      typeof middleware === "function"
        ? await middleware(response, request)
        : await middleware.handle(response, request);
    }

    // 2. Delegate to the core factory for the final return value
    return this.coreFactory(response, request);
  };
}
